<style lang="scss" scoped>
.ip-date-picker{
    position: relative;
    .ip-picker-panel{
        font-size: 12px;
        width: 260px;
        position: absolute;
        top: 33px;
        left: 0;
        z-index: 99;
        background-color: #fff;
        border-radius: 4px;
        line-height: 30px;
        border: solid 1px #e4e7ed;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        padding:0 6px 6px 6px;
        color:#606266;
        .disabled{
            color: #cccccc;
        }
        .date{
            cursor: pointer;
        }
        table{
            width: 100%;
            td, th {
                width: 24px;
                height: 24px;
                line-height: 24px;
                text-align: center;
                padding:0 4px;
            }
        }
        .month-table{
            padding-top: 1px;
            a{
                display: inline-block;
                width: 100%;
                height: 100%;
            }
            td{
                text-align: center;
                padding: 20px 3px;
                cursor: pointer;
            }
        }
        .check{
           color: $theme-color;  
        }
        .signed{
            border-radius: 50%;
            color: #fff;
            background:$theme-color;
        }
        .ip-date-picker-header{
            text-align: center;
            margin: 10px;
            vertical-align: middle;
            .icon-btn{
                font-size: 12px;
                color: #303133;
                border: 0;
                background: transparent;
                cursor: pointer;
                outline: none;
                margin-top: 8px;
            }
            .prev-btn{
                float: left;
            }
            .next-btn{
                float: right;
            }
            .click-span{
                font-size: 13px;
                cursor: pointer;
                font-weight: 600;
               
            }
            .click-span:hover{
                color: $theme-color;
            }
        }
    }
}
</style>
<template>
    <div v-clickoutside="handleClose" class="ip-date-picker">
        <el-input size="small" placeholder="选择日期" prefix-icon="el-icon-date" v-model="inputValue" @click.native="showDatePicker" @change.native="handleDateChange"></el-input>
           <div v-if="isShow" class="ip-picker-panel" :style="{top:aboveInput ? '-272px': '33px'}">
                <div class="ip-date-picker-header">
                    <button class="icon-btn prev-btn" @click="handlePrevYear"><i class="el-icon-d-arrow-left"></i></button>
                    <button class="icon-btn prev-btn" v-if="isShowDateView" @click="handlePrevMonth"><i class="el-icon-arrow-left"></i></button>
                    <span>
                        <span class="click-span" v-if="isShowMonthView || isShowDateView" @click="showYearView">{{current.year}} 年 </span>
                        <span class="click-span" v-if="!isShowMonthView && !isShowYearView" @click="showMonthView">{{current.month+1}} 月</span></span>
                        <span class="click-span" v-if="isShowYearView">{{yearRangeLeft}}-{{yearRangeRight}}</span>
                    <button class="icon-btn next-btn" @click="handleNextYear"><i class="el-icon-d-arrow-right"></i></button>
                    <button class="icon-btn next-btn" v-if="isShowDateView" @click="handleNextMonth"><i class="el-icon-arrow-right"></i></button>
                </div>
                <table v-if="isShowDateView" cellspacing="5" >
                    <tbody>
                        <tr>
                            <td>日</td>
                            <td>一</td>
                            <td>二</td>
                            <td>三</td>
                            <td>四</td>
                            <td>五</td>
                            <td>六</td>
                        </tr>
                        <tr v-for="row in list">
                            <td v-for="item in row" :class="{disabled: (current.month !== item.month) ? true : false}">
                                <div @click="checkDate(item)" class="date" :class="{check:(today.date === item.date && today.month === item.month && today.year === item.year)?true:false,signed:(current.date === item.date && current.month === item.month && current.year === item.year)?true:false}">{{item.date}}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table cellspacing="5" v-if="isShowMonthView" class="month-table">
                    <tbody>
                            <tr v-for="row in months">
                                <td v-for="item in row"><a :class="{check:(current.month === item.month)?true:false}" @click="CheckMonth(item)">{{item.value}}</a></td>
                            </tr>
                    </tbody>
                </table>
                <table cellspacing="5" v-if="isShowYearView" class="month-table">
                    <tbody>
                        <tr v-for="row in yearRangeList">
                            <td v-for="item in row"><a :class="{check:(current.year === item.year)?true:false}" @click="CheckYear(item)">{{item.year}}</a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
    </div>
</template>
<script>
export default {
    name:'ipDatePicker',
    props:{
        defaultValue:{type:String,default:''}
    },
    data(){
        return{
            isShow:false,
            isShowDateView:false,
            isShowYearView:false,
            isShowMonthView:false,
            inputValue:'',
            months: [
                [{ checked: false, value: '一月', month: 0},{ checked: false, value: '二月', month: 1},{ checked: false, value: '三月', month: 2 },{ checked: false, value: '四月', month: 3}],
                [{ checked: false, value: '五月', month: 4},{ checked: false, value: '六月', month: 5},{ checked: false, value: '七月', month: 6 },{ checked: false, value: '八月', month: 7 }],
                [{ checked: false, value: '九月', month: 8 },{ checked: false, value: '十月', month: 9},{ checked: false, value: '十一月', month: 10},{ checked: false, value: '十二月', month: 11}]
            ],
            list:[],
            prevMonth:[],
            nextMonth:[],
            monthDate:[],
            today:{
                year:0,
                month:0,
                date:0
            },
            current:{
                year:0,
                month:0,
                date:0
            },
            yearRangeList:[],
            yearRangeLeft:'',
            yearRangeRight:'',
            aboveInput:false
        }
    },
    mounted(){
        const now = new Date();
        this.today.year = now.getFullYear();
        this.today.month = now.getMonth();
        this.today.date = now.getDate();
        if(this.defaultValue.trim() === ''){
            this.current.year = this.today.year;
            this.current.month = this.today.month
        }else{
            this.inputValue = this.defaultValue;
        }
        this.fillDate();
    },
    methods:{
        handlePrevYear(){
            if(this.isShowYearView){
                this.yearRangeLeft -= 10 ;
                this.yearRangeRight -= 10;
                this.fillYearRange();
            }else{
                this.current.year--;
                this.emptyArray();
                this.fillDate();
            }
        },
        handleNextYear(){
            if(this.isShowYearView){
                this.yearRangeLeft += 10 ;
                this.yearRangeRight += 10;
                this.fillYearRange();
            }else{
                this.current.year++;
                this.emptyArray();
                this.fillDate();
            }
        },
        handlePrevMonth(){
            if (this.current.month === 0) {
                this.current.year--;
                this.current.month = 11;
            }else{
                this.current.month--
            }
            this.emptyArray();
            this.fillDate();    
        },
        handleNextMonth(){
            if (this.current.month === 11) {
                this.current.year++;
                this.current.month = 0;
            }else{
                this.current.month++;
            }
            this.emptyArray();
            this.fillDate();  
        },
        emptyArray(){
            this.list = [];
            this.prevMonth = [];
            this.nextMonth = [];
            this.monthDate = [];
        },
        handleDateChange(){
            const date = new Date(this.inputValue);
            if(!isNaN(date.getFullYear())){
                this.current.year = date.getFullYear();
                this.current.month = date.getMonth();
                this.current.date = date.getDate();
                this.emptyArray();
                this.fillDate();
            }
            this.isShow = false;
        },
        showDatePicker(event){
            const date = new Date(this.inputValue);
            if(!isNaN(date.getFullYear())){
                this.current.year = date.getFullYear();
                this.current.month = date.getMonth();
                this.current.date = date.getDate();
                this.emptyArray();
                this.fillDate();
            }
            this.isShow = true;
            this.isShowDateView = true;
            this.isShowYearView = false;
            this.isShowMonthView = false;
            let clientHeight = document.documentElement.clientHeight;
            let clientY = event.clientY;
            if(clientHeight-clientY < 272 && clientY > 272){
                this.aboveInput = true;
            }else{
                this.aboveInput = false;
            }
        },
        handleClose(){
            this.isShow = false;
        },
        checkDate(item){
            this.current.year = item.year;
            this.current.month = item.month;
            this.current.date = item.date;
            
            const month = item.month >= 9 ? item.month + 1 : '0' + (item.month + 1);
            const date = item.date > 9 ? item.date : '0' + item.date.toString();

            this.inputValue = item.year + '-' + month + '-' + date;
            this.isShow = false;
            this.emptyArray();
            this.fillDate();
            this.$emit('change',this.inputValue);
        },
        CheckMonth(item){
            this.current.month = item.month;
            this.isShowYearView = false;
            this.isShowMonthView = false;
            this.isShowDateView = true;
            this.emptyArray();
            this.fillDate();
        },
        CheckYear(item){
            this.current.year = item.year;
            this.isShowYearView = false;
            this.isShowMonthView = false;
            this.isShowDateView = true;
            this.emptyArray();
            this.fillDate();
        },
        showYearView(){
            this.yearRangeLeft = Math.floor(this.current.year/10)*10;
            this.yearRangeRight = this.yearRangeLeft + 9;
            this.fillYearRange();
            this.isShowYearView = true;
            this.isShowDateView = false;
            this.isShowMonthView = false;
        },
        showMonthView(){
            this.isShowYearView = false;
            this.isShowDateView = false;
            this.isShowMonthView = true;
        },
        fillYearRange(){
            let objArray = [];
            let yearItem = this.yearRangeLeft;
            for(let i = 0; i < 10; i++){
                objArray[i] = {
                    checked: false,
                    year: yearItem++,
                };
            }
            let len = objArray.length;
            let n = 4; //假设每行显示4个
            let lineNum = len % 4 === 0 ? len / 4 : Math.floor( (len / 4) + 1 );
            let res = [];
            for (let i = 0; i < lineNum; i++) {
                let temp = objArray.slice(i*n, i*n+n);
                res.push(JSON.parse(JSON.stringify(temp)));
            }
            this.yearRangeList = res;
        },
        fillDate() {
            const lastDate = new Date(this.current.year, this.current.month + 1, 0).getDate();

            for (let dayIndex = 0; dayIndex < lastDate; dayIndex++) {
                this.monthDate[dayIndex] = {
                    year: this.current.year,
                    month: this.current.month,
                    date: dayIndex + 1,
                    isChecked: false
                };
            }

            // 本月第一天是星期几（距星期日离开的天数）
            const startDay = new Date(this.current.year, this.current.month, 1).getDay();
            const prevMonthLastDay = new Date(this.current.year, this.current.month, 0).getDate();
            const prevMonth = this.current.month - 1 < 0 ? 11 : this.current.month - 1;
            for (let i = 1; i <= startDay; i++) {
                this.prevMonth[startDay - i] = {
                    year: this.current.month == 0 ? this.current.year - 1: this.current.year,
                    month: prevMonth,
                    date: prevMonthLastDay - i + 1,
                    isChecked: false
                };
            }
            
            let lastDay = 6 - (new Date(this.current.year, this.current.month + 1, 0).getDay());
            if (this.monthDate.length + this.prevMonth.length <= 35) {
                lastDay = lastDay + 7;
            }
            const nextMonth = this.current.month + 1 > 11 ? 0 : this.current.month + 1;
            for (let i = 1; i <= lastDay; i++) {
                this.nextMonth.push({
                    year: this.current.month == 11 ? this.current.year + 1 : this.current.year,
                    month: nextMonth,
                    date: i,
                    isChecked: false
                });
            }

            const temp = this.prevMonth.concat(this.monthDate, this.nextMonth);
            const length = temp.length;
            let row = [];
            for (let i = 0; i < length; i++) {
                if (i % 7 === 0) {
                    this.list.push(row);
                    row = [];
                }
                row.push(temp[i]);
            }
            this.list.push(row);
        }
    }
}
</script>